import BaseRequest from './BaseRequest';

const schema = 'user';
const market = 'setting';
/**
 * key base on host:port
 */
export default class LoginRequest extends BaseRequest {
  /**
	 * @param {Object} params
	 * @param {string} params.step
	 * @param {string} params.code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  waitForConfirm(params) {
    const url = `${schema}/confirm`;
    return this.getWithTimeout(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.phone
	 * @param {string} params.password
	 * @param {string} params.term
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  register(params) {
    const url = `${schema}/register`;
    return this.post(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.username
	 * @param {string} params.password
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  loginNormal(params) {
    const url = `${schema}/login-normal`;
    return this.post(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.token
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  verifyEmail(params) {
    const url = `${schema}/verify`;
    return this.post(url, params);
  }

  /**
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  logout(params) {
    const url = `${schema}/logout`;
    return this.post(url, params);
  }

  /**
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  loginQR1(params = {}) {
    const url = `${schema}/login`;
    return this.getWithTimeout(url, params, 60 * 1000);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  loginQR2(params = {}) {
    const url = `${schema}/qr-verify`;
    return this.getWithTimeout(url, params, 60 * 1000);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  loginQR3(params = {}) {
    const url = `${schema}/qr-confirm`;
    return this.getWithTimeout(url, params, 60 * 1000);
  }

  fetchMarkets() {
    const url = `${market}/markets`;
    return this.get(url);
  }
}
